import Cookies from 'js-cookie';
import { IJwt, IUserDataCookie } from '../_types/jwt';

export const getSessionCookie = () : SessionData | null => {
    const userDataCookie = Cookies.get('userData');

    let toReturn: SessionData | null = null as any;
    if (userDataCookie) {
    
        let asCookie: IUserDataCookie = JSON.parse(userDataCookie);

        toReturn = new SessionData(asCookie);
    }
    return toReturn;
}

export const setSessionCookie = (cookie: SessionData | null) => {

    const host = window.location.hostname.split('.');
    const domain = `${host[1]}.${host[2]}`;

    if (cookie) {
        Cookies.set('userData', JSON.stringify(cookie.getCookie()), { path: '/', domain: `.${domain}` })
     //Cookies.set('userData', JSON.stringify(cookie.getCookie()), { path: '/', domain: '.everwash.com'})
    } else {
        Cookies.remove('userData', { path: '/', domain: `.${domain}` });
        //Cookies.remove('userData', { path: '/', domain: '.everwash.com' });
    }
}

export class SessionData {
    protected cookie: IUserDataCookie;

    constructor(sessionCookie: IUserDataCookie) {
        this.cookie = sessionCookie;

        
    }

    getCookie = (): IUserDataCookie => { return this.cookie; }
    setJwt = (jwt: string) => {
        this.cookie.jwt = jwt;
    }
    getRawJWT = (): string => {
        return this.cookie.jwt;
    }
    getUserId = (): number => {
        return parseInt(this.getJWT().sub);
    }

    getJWT = (): IJwt => {
        const base64 = this.getRawJWT().split('.')[1];
        const jwt = window.atob(base64.replace('-', '+').replace('_', '/'));
        
        return JSON.parse(jwt);
    }

    GetJwtExpiresAt = (): Date => {
        const d = new Date(0);
        d.setUTCSeconds(this.getJWT().exp);
        return d;
    }   

    GetJwtHeader = (): Record<string,string> => {
        return { "Authorization": "Bearer " + this.getRawJWT() };
    }
}
